export const printIframe = (iframeId: string, content: string) => {
    try {
        let iframe = document.getElementById(iframeId) as HTMLIFrameElement;

        if (!iframe) {
            iframe = document.createElement('iframe');
            iframe.id = iframeId;
            iframe.name = iframeId;
            iframe.width = '0';
            iframe.height = '0';
            // @ts-ignore
            iframe.style = 'position: absolute;top: 0;left: 0;width: 0;height: 0;';
            document.body.appendChild(iframe);
        }

        iframe.contentWindow?.document.open();
        iframe.contentWindow?.document.write(content);
        iframe.contentWindow?.document.close();

        window.frames[iframeId as any].focus();
        // для загрузки картинок нужно время
        setTimeout(() => {
            window.frames[iframeId as any].print();
        }, 1000);
    } catch (error) {
        console.error('Error printing: ' + error.message);
    }
};
